import * as React from "react";

/**
 * Indeterminate progress ring for uploading and transcoding. Takes the colour of its text
 * (currentColor), so it matches the label it sits beside.
 */
export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** px. Default 16. */
  size?: number;
  /** Accessible name. Default "Loading". Pass "" when a visible label beside it already says what is happening. */
  label?: string;
}

export function Spinner({ size = 16, label = "Loading", className, ...rest }: SpinnerProps): JSX.Element {
  const a11y = label ? { role: "status", "aria-label": label } : { "aria-hidden": true };
  return (
    <span className={["gk-spinner", className].filter(Boolean).join(" ")} {...a11y} {...rest}>
      <svg width={size} height={size} viewBox="0 0 16 16" className="gk-spinner__ring" aria-hidden="true">
        <circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" strokeOpacity="0.22" strokeWidth="2" />
        <path d="M8 1.5A6.5 6.5 0 0 1 14.5 8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </span>
  );
}
